import { IHttpApi } from '@cian/http-api/shared';

import {
  TGetInfrastructureRequest,
  TGetInfrastructureResponse,
  fetchGetInfrastructure,
} from '../../repositories/infrastructure-caching/v4/get-infrastructure';
import { IGetInfrastructureV4Response } from '../../repositories/infrastructure-caching/entities/get_infrastructure/GetInfrastructureV4Response';
import { assertUnknownError } from './assert';

export async function getInfrastructureRequest({
  httpApi,
  parameters,
}: {
  httpApi: IHttpApi;
  parameters: TGetInfrastructureRequest;
}): Promise<IGetInfrastructureV4Response> {
  const response: TGetInfrastructureResponse = await fetchGetInfrastructure({ httpApi, parameters });

  assertUnknownError(response);

  return response.response;
}
